import Bugsnag from '@bugsnag/js';
import { thunkBounceSeatedPlayerFromInbound } from '../../redux/actions/animationsActions';
import { thunkAddBombFromInbound } from '../../redux/actions/bombsActions';
import { addActionResultChatItem, addHtmlChatItem, setBlockedChatPlayersFromInbound, thunkAddPlayerMessageChatItemFromInbound } from '../../redux/actions/chatActions';
import { setNextTourneyFromInbound, showRebuyWindowFromInbound, thunkAddActionErrorFromInbound, thunkFreeDailyBonusSuccessFromInbound, thunkShowPrizeWinFromInbound } from '../../redux/actions/commonActions';
import { becomeOwner, forceReload, setPlayerBankFromInbound } from '../../redux/actions/commonReduxActions';
import { addFriendToAllFromInbound, hideFriendRequestFromInbound, removeFriendFromAllFromInbound, setActiveContactsFromInbound, setAllFriendsFromInbound, setContactActiveFromInbound, setContactInactiveFromInbound, showFriendRequestFromInbound } from '../../redux/actions/contactsActions';
import { setRecentConversationsFromInbound, thunkAddDirectMessageFromInbound, thunkHandleDirectMessageBlankFromInbound, thunkSetDirectMessageLogFromInbound } from '../../redux/actions/directMessagesActions';
import { setFooterAlert } from '../../redux/actions/footerAlertActions';
import { setLoginString, showLoginWindowFromInbound, thunkHandleVersionCheckResultsFromInbound, thunkLoginNow } from '../../redux/actions/gameEntryActions';
import { addRoomsToLobby, addRoomToLobby, removeRoomFromLobby, renameLobbyRoomFromInbound, thunkEnterLobbyPlayerFromInbound, thunkLeaveLobbyPlayerFromInbound, thunkLobbyBrowseFromInbound, updateLobbyRoomFromInbound, updateLobbyRoomVariableFromInbound } from '../../redux/actions/lobbyActions';
import { addMessageBox, showAdminNewestPlayersListMessageBoxFromInbound, showConfirmWindowMessageBoxFromInbound, showGiveChipsMessageBoxFromInbound, showJacksWindowMessageBoxFromInbound, showLoginErrorMessageBoxFromInbound, showNewestPlayersListMessageBoxFromInbound, showPlayerDebugInfoMessageBoxFromInbound, showPowerPlayerUpgradeMessageBoxFromInbound, showRecentAdminActionsMessageBoxFromInbound, showSignUpErrorMessageBoxFromInbound, showTestEmailLogMessageBoxFromInbound, showTourneySummaryMessageBoxFromInbound, thunkAddMessageBoxFromInbound, thunkShowUpcomingTourneysMessageBoxFromInbound } from '../../redux/actions/messageBoxesActions';
import { clearTourneyStandings, closeMttTableFromInbound, setNumMttTables, thunkUpdateTourneyStandingsFromInbound } from '../../redux/actions/mttActions';
import { renameMttStagingRoom, setMttStagingTablesFromInbound, thunkEnterMttStagingPlayerFromInbound, thunkInitMttStagingFromInbound, thunkLeaveMttStagingPlayerFromInbound, updateMttStagingInfoFromInbound, updateMttStagingPlayerReadyStateFromInbound, updateMttStagingPlayersFromInbound, updateMttStagingTableFromInbound } from '../../redux/actions/mttStagingActions';
import { thunkShowPlayerBubbleFromInbound } from '../../redux/actions/playerBubblesActions';
import { thunkShowPlayerInfoFromInbound, updatePlayerBlockingFromInbound } from '../../redux/actions/playerInfoActions';
import { handReconnectFromInbound, renamePokerRoom, setBlindTimerFromInbound, setDiscardPhaseDoneFromInbound, setDiscardPhaseFromInbound, setHandRevealingFromInbound, setHoleCardsAfterDiscardFromInbound, setPlayerHadDiscardedFromInbound, setPokerRoomInfoFromInbound, setPokerRoomStatus, setSitOutSelfStatusFromInbound, setSitOutStatusFromInbound, standUpDelayedFromInbound, startSeatTimersFromInbound, thunkBetFromInbound, thunkEnterPokerPlayerFromInbound, thunkHandWinFromInbound, thunkInitPokerRoomFromInbound, thunkLeavePokerPlayerFromInbound, thunkSetSeatedPlayerAvatarFromInbound, thunkSetSideBetPhaseFromInbound, thunkShowAllInCommunityCardsFromInbound, thunkShowAllInHandsFromInbound, thunkShowBlankChatBubbleFromInbound, thunkSitPlayerFromInbound, thunkStandUpFromInbound, thunkStartHandFromInbound, thunkStartShowdown, thunkWaitPhaseFromInbound, updateChipStacksFromInbound, updateHandRankFromInbound, updateLastChipStackFromInbound, updatePlayersFromInbound, updatePlayersMedalsAndStyleFromInbound, updatePotAmountsFromInbound } from '../../redux/actions/pokerActions';
import { setCheckRecoverLoginResultFromInbound, setRecoverLoginStatus, setResetPasswordError } from '../../redux/actions/recoverLoginActions';
import { askReverifyEmailAccountFromInbound, setReverifyNewEmailVerificationSentFromInbound, setReverifyPage, thunkUpdateReverifyEmailErrorFromInbound } from '../../redux/actions/reverifyActions';
import { thunkSetScene } from '../../redux/actions/sceneActions';
import { rebuySuccessFromInbound, setSelfPowerPlayerStatus, thunkSetSelfDataFromInbound, thunkShowSelfInfoFromInbound, thunkUpdatePlayerServerSettingFromInbound, updateJacksAndAmmoFromInbound } from '../../redux/actions/selfDataActions';
import { setBadBeatJackpotAmountFromInbound, thunkSetSessionIdFromInbound } from '../../redux/actions/sessionActions';
import { thunkAddSideBetFromInbound, thunkHandleSideBetRefundedFromInbound, thunkShowSideBetHandCompleteFromInbound, thunkShowSideBetHandIncomplete, thunkSideBetDoneFromInbound } from '../../redux/actions/sideBetsActions';
import { thunkStartTransitionAnimation } from '../../redux/actions/transitionAnimationActions';
import { setVerifyAccountDone, setVerifyAccountErrorFromInbound } from '../../redux/actions/verifyAccountActions';
import { removeAutoReconnectSessionUuid } from '../../utils/autoReconnectUtils';
import { maybeConsoleLogInbound } from '../../utils/consoleUtils';
import { handleDebugInfoRequest } from '../../utils/debugInfoUtils';
import { createInfiniteLoop } from '../../utils/infiniteLoopUtils';
import { truthyFilter } from '../../utils/tsUtils';
import { delay, isTestEnvironment } from '../../utils/utils';
import { INBOUND_DEFINITIONS } from './inboundDefinitions';
import { splitWithBraces } from './inboundUtils';
function thunkJoinRoom(inbound) {
    return async function (dispatch, getState) {
        // In tests, there are times when multiple players joining the same room at the same time can cause a race condition,
        // for example in an MTT where a player arrives before another, despite being told by the server to join first.
        // We can add an artificial delay based on instance ID to reduce the chances of this kind of race condition.
        const joinHandleDelayMs = isTestEnvironment() ? getState().instanceId.instanceId * 50 : 0;
        if (joinHandleDelayMs) {
            await delay(joinHandleDelayMs);
        }
        dispatch(thunkSetSelfDataFromInbound(inbound.inboundSelfData));
        dispatch(thunkStartTransitionAnimation(inbound.scene, inbound.loadingRoomMessage));
    };
}
export const INBOUND_HANDLERS = {
    choose_username_error: (inbound, { dispatch }) => {
        dispatch(showSignUpErrorMessageBoxFromInbound(inbound));
    },
    login_error: (inbound, { dispatch }) => {
        dispatch(showLoginErrorMessageBoxFromInbound(inbound));
    },
    login_strs: (inbound, { dispatch }) => {
        const { loginString } = inbound;
        dispatch(setLoginString(loginString));
    },
    login_win: (inbound, { dispatch }) => {
        dispatch(showLoginWindowFromInbound(inbound));
    },
    login_now: (inbound, { dispatch }, socketSend) => {
        dispatch(thunkLoginNow(socketSend));
    },
    join_lounge: (inbound, { dispatch }, socketSend) => {
        dispatch(thunkSetScene('loading', socketSend));
    },
    lbrowse_v2: (inbound, { dispatch }) => {
        dispatch(thunkLobbyBrowseFromInbound(inbound));
    },
    addgames: (inbound, { dispatch }) => {
        dispatch(addRoomsToLobby(inbound.lobbyRooms));
    },
    gamesdone: (inbound, { dispatch }, socketSend) => {
        dispatch(thunkSetScene('lobby', socketSend));
    },
    join: (inbound, { dispatch }) => {
        dispatch(thunkJoinRoom(inbound));
    },
    self_data: (inbound, { dispatch }) => {
        // only received in poker room
        dispatch(thunkSetSelfDataFromInbound(inbound.inboundSelfData));
    },
    action_result: (inbound, { dispatch }) => {
        dispatch(addActionResultChatItem(inbound.message));
    },
    action_error: (inbound, { dispatch }) => {
        dispatch(thunkAddActionErrorFromInbound(inbound));
    },
    keepalive: () => {
        // 'keepalive:' inbounds are to be ignored by the client, do nothing
    },
    lounge: (inbound, { dispatch }) => {
        dispatch(thunkStartTransitionAnimation('roomToLobby', inbound.loadingRoomMessage));
    },
    init_game_data_v2: (inbound, { dispatch }) => {
        dispatch(thunkInitPokerRoomFromInbound(inbound));
    },
    sit: (inbound, { dispatch }) => {
        dispatch(thunkSitPlayerFromInbound(inbound));
    },
    su: (inbound, { dispatch }) => {
        dispatch(thunkStandUpFromInbound(inbound));
    },
    sud: (inbound, { dispatch }) => {
        dispatch(standUpDelayedFromInbound(inbound));
    },
    enter: (inbound, { dispatch }) => {
        dispatch(thunkEnterPokerPlayerFromInbound(inbound));
    },
    h: (inbound, { dispatch }) => {
        dispatch(thunkStartHandFromInbound(inbound));
    },
    start_seat_timers: (inbound, { dispatch }) => {
        dispatch(startSeatTimersFromInbound(inbound));
    },
    bet: (inbound, { dispatch }, socketSend) => {
        dispatch(thunkBetFromInbound(inbound, socketSend));
    },
    win: (inbound, { dispatch }) => {
        dispatch(thunkHandWinFromInbound(inbound));
    },
    show: (inbound, { dispatch }) => {
        dispatch(thunkShowAllInHandsFromInbound(inbound));
    },
    flop: (inbound, { dispatch }) => {
        dispatch(thunkShowAllInCommunityCardsFromInbound(inbound));
    },
    wait: (inbound, { dispatch }) => {
        dispatch(thunkWaitPhaseFromInbound(inbound));
    },
    next_win_anim: (inbound, { dispatch }) => {
        dispatch(thunkStartShowdown(inbound.potIndex));
    },
    btimer: (inbound, { dispatch }) => {
        dispatch(setBlindTimerFromInbound(inbound));
    },
    update_players: (inbound, { dispatch }) => {
        dispatch(updatePlayersFromInbound(inbound));
    },
    c: (inbound, { dispatch }) => {
        dispatch(addHtmlChatItem(inbound.html));
    },
    lempty: (inbound, { dispatch }) => {
        dispatch(removeRoomFromLobby(inbound.roomId));
    },
    lcreate: (inbound, { dispatch }) => {
        dispatch(addRoomToLobby(inbound.lobbyRoom));
    },
    pc: (inbound, { dispatch }) => {
        dispatch(thunkAddPlayerMessageChatItemFromInbound(inbound));
    },
    leave: (inbound, { dispatch }) => {
        dispatch(thunkLeavePokerPlayerFromInbound(inbound));
    },
    friends_online: (inbound, { dispatch }) => {
        dispatch(setActiveContactsFromInbound(inbound));
    },
    friend_hide_active: (inbound, { dispatch }) => {
        dispatch(setContactInactiveFromInbound(inbound));
    },
    friend_active: (inbound, { dispatch }) => {
        dispatch(setContactActiveFromInbound(inbound));
    },
    friend_show_request: (inbound, { dispatch }) => {
        dispatch(showFriendRequestFromInbound(inbound));
    },
    friend_hide_request: (inbound, { dispatch }) => {
        dispatch(hideFriendRequestFromInbound(inbound));
    },
    upd_player_bank: (inbound, { dispatch }) => {
        dispatch(setPlayerBankFromInbound(inbound));
    },
    sitout_self: (inbound, { dispatch }) => {
        dispatch(setSitOutSelfStatusFromInbound(inbound));
    },
    sitout: (inbound, { dispatch }) => {
        dispatch(setSitOutStatusFromInbound(inbound));
    },
    privatemsg: (inbound, { dispatch }, socketSend) => {
        dispatch(thunkAddDirectMessageFromInbound(inbound, socketSend));
    },
    privatemsg_blank: (inbound, { dispatch }) => {
        dispatch(thunkHandleDirectMessageBlankFromInbound(inbound));
    },
    privatemsg_log: (inbound, { dispatch }, socketSend) => {
        dispatch(thunkSetDirectMessageLogFromInbound(inbound, socketSend));
    },
    private_msgs_recent: (inbound, { dispatch }) => {
        dispatch(setRecentConversationsFromInbound(inbound));
    },
    lenter: (inbound, { dispatch }) => {
        dispatch(thunkEnterLobbyPlayerFromInbound(inbound));
    },
    lleave: (inbound, { dispatch }) => {
        dispatch(thunkLeaveLobbyPlayerFromInbound(inbound));
    },
    poker_room_info: (inbound, { dispatch }) => {
        dispatch(setPokerRoomInfoFromInbound(inbound));
    },
    hand_recon: (inbound, { dispatch }) => {
        dispatch(handReconnectFromInbound(inbound));
    },
    msgbox: (inbound, { dispatch }) => {
        dispatch(thunkAddMessageBoxFromInbound(inbound));
    },
    rebuy_win: (inbound, { dispatch }) => {
        dispatch(showRebuyWindowFromInbound(inbound));
    },
    become_owner: (inbound, { dispatch }) => {
        dispatch(becomeOwner());
    },
    cbrowse_v2: (inbound, { dispatch }) => {
        dispatch(thunkInitMttStagingFromInbound(inbound));
    },
    clounge: (inbound, { dispatch }) => {
        dispatch(thunkStartTransitionAnimation('roomToLobby', inbound.loadingRoomMessage));
    },
    center: (inbound, { dispatch }) => {
        dispatch(thunkEnterMttStagingPlayerFromInbound(inbound));
    },
    mtt_update_player_ready_state: (inbound, { dispatch }) => {
        dispatch(updateMttStagingPlayerReadyStateFromInbound(inbound));
    },
    lc: (inbound, { dispatch }) => {
        dispatch(addHtmlChatItem(inbound.html));
    },
    cleave: (inbound, { dispatch }) => {
        dispatch(thunkLeaveMttStagingPlayerFromInbound(inbound));
    },
    mtt_info_box: (inbound, { dispatch }) => {
        dispatch(updateMttStagingInfoFromInbound(inbound));
    },
    hand_rank: (inbound, { dispatch }) => {
        dispatch(updateHandRankFromInbound(inbound));
    },
    update_profile_win: () => {
        // deprecated, now responding to 'player_info:' and 'self_info:' inbounds
    },
    cc: (inbound, { dispatch }) => {
        dispatch(addHtmlChatItem(inbound.html));
    },
    mtt_tables: (inbound, { dispatch }) => {
        dispatch(setNumMttTables(inbound.numMttTables));
    },
    stat: (inbound, { dispatch }) => {
        dispatch(setPokerRoomStatus(inbound.html));
    },
    mtt_close: (inbound, { dispatch }) => {
        dispatch(closeMttTableFromInbound());
    },
    tourney_summary: (inbound, { dispatch }) => {
        dispatch(showTourneySummaryMessageBoxFromInbound(inbound));
    },
    mtt_full: (inbound, { dispatch }) => {
        dispatch(setMttStagingTablesFromInbound(inbound));
    },
    mtt_update: (inbound, { dispatch }) => {
        dispatch(updateMttStagingTableFromInbound(inbound));
    },
    chips_win: (inbound, { dispatch }) => {
        dispatch(addMessageBox({
            type: 'jacks-to-chips',
            jacksToChipsOptions: inbound.jacksToChipsOptions
        }));
    },
    jacks: (inbound, { dispatch }) => {
        dispatch(updateJacksAndAmmoFromInbound(inbound));
    },
    lupd_lounge_players: (inbound, { dispatch }) => {
        dispatch(setPlayerBankFromInbound(inbound));
    },
    power_player_win: (inbound, { dispatch }) => {
        dispatch(showPowerPlayerUpgradeMessageBoxFromInbound(inbound));
    },
    income_win: (inbound, { dispatch }) => {
        const { incomeEventId, fromPlayerId, incomeAmount, incomeEventType, message } = inbound;
        dispatch(addMessageBox({
            type: 'income-event',
            incomeEventId,
            fromPlayerId,
            incomeAmount,
            incomeEventType,
            message
        }));
    },
    discard_phase: (inbound, { dispatch }) => {
        dispatch(setDiscardPhaseFromInbound(inbound));
    },
    power_player: (inbound, { dispatch }) => {
        dispatch(setSelfPowerPlayerStatus(inbound.isPowerPlayer));
    },
    confirm_win: (inbound, { dispatch }) => {
        dispatch(showConfirmWindowMessageBoxFromInbound(inbound));
    },
    lupd: (inbound, { dispatch }) => {
        dispatch(updateLobbyRoomFromInbound(inbound));
    },
    pots: (inbound, { dispatch }) => {
        dispatch(updatePotAmountsFromInbound(inbound));
    },
    face: (inbound, { dispatch }) => {
        dispatch(thunkSetSeatedPlayerAvatarFromInbound(inbound));
    },
    next_tourney_win: (inbound, { dispatch }) => {
        dispatch(setNextTourneyFromInbound(inbound));
    },
    medals_style: (inbound, { dispatch }) => {
        dispatch(updatePlayersMedalsAndStyleFromInbound(inbound));
    },
    player_info: (inbound, { dispatch }) => {
        dispatch(thunkShowPlayerInfoFromInbound(inbound));
    },
    update_player_blocking: (inbound, { dispatch }) => {
        dispatch(updatePlayerBlockingFromInbound(inbound));
    },
    self_info: (inbound, { dispatch }) => {
        dispatch(thunkShowSelfInfoFromInbound(inbound));
    },
    update_room_var: (inbound, { dispatch }) => {
        dispatch(updateLobbyRoomVariableFromInbound(inbound));
    },
    standings_data: (inbound, { dispatch }) => {
        dispatch(thunkUpdateTourneyStandingsFromInbound(inbound));
    },
    clear_standings_data: (inbound, { dispatch }) => {
        dispatch(clearTourneyStandings());
    },
    newbomb: (inbound, { dispatch }) => {
        dispatch(thunkAddBombFromInbound(inbound));
    },
    jacks_win: (inbound, { dispatch }) => {
        dispatch(showJacksWindowMessageBoxFromInbound(inbound));
    },
    bounce_player: (inbound, { dispatch }) => {
        dispatch(thunkBounceSeatedPlayerFromInbound(inbound));
    },
    option: (inbound, { dispatch }, socketSend) => {
        dispatch(thunkUpdatePlayerServerSettingFromInbound(inbound, socketSend));
    },
    dropdowns: () => {
        // TODO
    },
    cpls: (inbound, { dispatch }) => {
        dispatch(updateMttStagingPlayersFromInbound(inbound));
    },
    friends_all_v2: (inbound, { dispatch }) => {
        dispatch(setAllFriendsFromInbound(inbound));
    },
    friend_add_to_all: (inbound, { dispatch }) => {
        dispatch(addFriendToAllFromInbound(inbound));
    },
    friend_remove_from_all: (inbound, { dispatch }) => {
        dispatch(removeFriendFromAllFromInbound(inbound));
    },
    reveal_this_hand: (inbound, { dispatch }) => {
        dispatch(setHandRevealingFromInbound(inbound));
    },
    bubble: (inbound, { dispatch }) => {
        dispatch(thunkShowPlayerBubbleFromInbound(inbound));
    },
    account_info: (inbound, { dispatch }) => {
        dispatch(addMessageBox({ type: 'account', email: inbound.email }));
    },
    blocked_chat_sql_ids: (inbound, { dispatch }) => {
        dispatch(setBlockedChatPlayersFromInbound(inbound));
    },
    warn_aggro_betting: (inbound, { dispatch }) => {
        dispatch(setFooterAlert({ message: 'Warning! Continued Aggressive Betting may ban you from this room.' }));
    },
    hole_cards_after_discard: (inbound, { dispatch }) => {
        dispatch(setHoleCardsAfterDiscardFromInbound(inbound));
    },
    discard_done: (inbound, { dispatch }) => {
        dispatch(setDiscardPhaseDoneFromInbound(inbound));
    },
    discard_by_seat: (inbound, { dispatch }) => {
        dispatch(setPlayerHadDiscardedFromInbound(inbound));
    },
    il: () => {
        createInfiniteLoop();
    },
    last_chip_stack: (inbound, { dispatch }) => {
        dispatch(updateLastChipStackFromInbound(inbound));
    },
    verify_account_error: (inbound, { dispatch }) => {
        dispatch(setVerifyAccountErrorFromInbound(inbound));
    },
    verify_account_done: (inbound, { dispatch }) => {
        dispatch(setVerifyAccountDone());
    },
    ranking_list: (inbound, { dispatch }) => {
        dispatch(addMessageBox({ type: 'ranking-list', rankingList: inbound }));
    },
    chat_blank: (inbound, { dispatch }) => {
        dispatch(thunkShowBlankChatBubbleFromInbound(inbound));
    },
    side_bet_done: (inbound, { dispatch }) => {
        dispatch(thunkSideBetDoneFromInbound(inbound));
    },
    show_give_chips: (inbound, { dispatch }) => {
        dispatch(showGiveChipsMessageBoxFromInbound(inbound));
    },
    recent_tourney_winners: (inbound, { dispatch }) => {
        dispatch(addMessageBox({ type: 'recent-tourney-winners', recentTourneyWinners: inbound.recentTourneyWinners }));
    },
    request_debug_info: (inbound, store, socketSend) => {
        handleDebugInfoRequest(inbound, store, socketSend);
    },
    show_player_debug_info: (inbound, { dispatch }) => {
        dispatch(showPlayerDebugInfoMessageBoxFromInbound(inbound));
    },
    newest_players_list: (inbound, { dispatch }) => {
        dispatch(showNewestPlayersListMessageBoxFromInbound(inbound));
    },
    admin_newest_players_list: (inbound, { dispatch }) => {
        dispatch(showAdminNewestPlayersListMessageBoxFromInbound(inbound));
    },
    rename_current_room: (inbound, store) => {
        const { dispatch, getState } = store;
        switch (getState().scene.roomSceneType) {
            case 'poker': {
                dispatch(renamePokerRoom(inbound.newName));
                break;
            }
            case 'mttStaging': {
                dispatch(renameMttStagingRoom(inbound.newName));
                break;
            }
        }
    },
    rename_room: (inbound, { dispatch }) => {
        dispatch(renameLobbyRoomFromInbound(inbound));
    },
    recent_admin_actions: (inbound, { dispatch }) => {
        dispatch(showRecentAdminActionsMessageBoxFromInbound(inbound));
    },
    prize_win_v2: (inbound, { dispatch }) => {
        dispatch(thunkShowPrizeWinFromInbound(inbound));
    },
    set_bad_beat_jackpot_amount: (inbound, { dispatch }) => {
        dispatch(setBadBeatJackpotAmountFromInbound(inbound));
    },
    update_chip_stacks: (inbound, { dispatch }) => {
        dispatch(updateChipStacksFromInbound(inbound));
    },
    show_upcoming_tourneys: (inbound, { dispatch }) => {
        dispatch(thunkShowUpcomingTourneysMessageBoxFromInbound(inbound));
    },
    version_check_results: (inbound, { dispatch }, socketSend) => {
        dispatch(thunkHandleVersionCheckResultsFromInbound(inbound, socketSend));
    },
    show_test_email_log: (inbound, { dispatch }) => {
        dispatch(showTestEmailLogMessageBoxFromInbound(inbound));
    },
    side_bet_phase: (inbound, { dispatch }) => {
        dispatch(thunkSetSideBetPhaseFromInbound(inbound));
    },
    side_bet_added: (inbound, { dispatch }) => {
        dispatch(thunkAddSideBetFromInbound(inbound));
    },
    side_bet_hand_complete: (inbound, { dispatch }) => {
        dispatch(thunkShowSideBetHandCompleteFromInbound(inbound));
    },
    side_bet_hand_incomplete: (inbound, { dispatch }) => {
        dispatch(thunkShowSideBetHandIncomplete());
    },
    side_bet_refunded: (inbound, { dispatch }) => {
        dispatch(thunkHandleSideBetRefundedFromInbound(inbound));
    },
    reload: (inbound, { dispatch }) => {
        dispatch(forceReload());
    },
    rebuy_success: (inbound, { dispatch }) => {
        dispatch(rebuySuccessFromInbound(inbound));
    },
    free_daily_bonus_success: (inbound, { dispatch }) => {
        dispatch(thunkFreeDailyBonusSuccessFromInbound(inbound));
    },
    show_tourney_details: (inbound, { dispatch }) => {
        dispatch(addMessageBox({ type: 'tourney-details', tourneyDetails: inbound }));
    },
    check_recover_login_result: (inbound, { dispatch }) => {
        dispatch(setCheckRecoverLoginResultFromInbound(inbound));
    },
    reset_password_error: (inbound, { dispatch }) => {
        dispatch(setResetPasswordError(inbound.error));
    },
    reset_password_done: (inbound, { dispatch }) => {
        dispatch(setRecoverLoginStatus('success'));
    },
    ask_reverify_email_account: (inbound, { dispatch }, socketSend) => {
        dispatch(thunkSetScene('reverify', socketSend));
        dispatch(askReverifyEmailAccountFromInbound(inbound));
    },
    reverify_current_email_verification_sent: (inbound, { dispatch }) => {
        dispatch(setReverifyPage('current-email-verification-sent'));
    },
    update_reverify_email_error: (inbound, { dispatch }) => {
        dispatch(thunkUpdateReverifyEmailErrorFromInbound(inbound));
    },
    reverify_new_email_verification_sent: (inbound, { dispatch }) => {
        dispatch(setReverifyNewEmailVerificationSentFromInbound(inbound));
    },
    session_id: (inbound, { dispatch }) => {
        dispatch(thunkSetSessionIdFromInbound(inbound));
    },
    player_lost_connection: () => {
        // TODO
    },
    auto_reconnect_invalid: () => {
        removeAutoReconnectSessionUuid();
    }
};
function isKnownInbound(rawInboundType) {
    return !!INBOUND_DEFINITIONS[rawInboundType];
}
function getInboundType(rawInbound) {
    const colonPos = rawInbound.indexOf(':');
    if (colonPos === -1) {
        return null;
    }
    const rawInboundType = rawInbound.substring(0, colonPos);
    if (!isKnownInbound(rawInboundType)) {
        return null;
    }
    return rawInboundType;
}
/**
 * Inbound prefixes that either can't be supported, or for which there are no plans to support.
 * TODO: Audit these on the server and remove or change any that are no longer relevant.
 */
const IGNORED_INBOUND_PREFIXES = ['turn_state:'];
export function parseRawSingleInbound(rawInbound, instanceId = 0) {
    const inboundType = getInboundType(rawInbound);
    if (!inboundType) {
        // no type or no inbound definition
        if (IGNORED_INBOUND_PREFIXES.some((ignoredInboundPrefix) => rawInbound.startsWith(ignoredInboundPrefix))) {
            console.log(`%c[${instanceId}] Ignored inbound %s`, 'color: #555555; font-size: 8px; font-weight: bold;', rawInbound);
        }
        else {
            console.log(`%c[${instanceId}] Unhandled inbound %s`, 'color: #CC6600', rawInbound);
        }
        return;
    }
    const paramsStr = rawInbound.substring(rawInbound.indexOf(':') + 1);
    let parsedInbound;
    try {
        parsedInbound = parseInboundParams(inboundType, paramsStr);
    }
    catch {
        Bugsnag.notify(new Error(`Error parsing ${rawInbound}`));
        console.error(`%c[${instanceId}] Error parsing inbound %s`, 'color: #FF0000', rawInbound);
        return;
    }
    maybeConsoleLogInbound(inboundType, parsedInbound, rawInbound, instanceId);
    return parsedInbound;
}
/**
 * "Multi" inbounds are in the form:
 * #(label):/[inbound-A-length]/[inbound-A]/[inbound-B-length]/[inbound-B]...
 */
// TODO: Add tests.
export function parseRawMultiInbound(rawMultiInbound, instanceId = 0) {
    let restStr = rawMultiInbound.substring(rawMultiInbound.indexOf(':') + 1); // jump over '#(label):'
    const rawInbounds = [];
    while (restStr.startsWith('/')) {
        restStr = restStr.substring(1); // remove first slash
        const currentRawInboundLength = Number(restStr.substring(0, restStr.indexOf('/')));
        restStr = restStr.substring(restStr.indexOf('/') + 1); // remove second slash
        const currRawInbound = restStr.substring(0, currentRawInboundLength);
        rawInbounds.push(currRawInbound);
        restStr = restStr.substring(currentRawInboundLength); // remove current inbound string
    }
    return rawInbounds.map((rawInbound) => parseRawSingleInbound(rawInbound, instanceId));
}
export function parseRawInbound(rawInbound, instanceId = 0) {
    const parseResults = rawInbound.startsWith('#')
        ? parseRawMultiInbound(rawInbound, instanceId)
        : [parseRawSingleInbound(rawInbound, instanceId)];
    return parseResults.filter(truthyFilter); // remove falsy inbounds, if any
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseInboundPayload(inboundParts, inboundPartDefinitions) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const inbound = inboundPartDefinitions.reduce((acc, currInboundPart) => {
        const nextInboundPart = inboundParts.shift();
        acc[currInboundPart.name] = currInboundPart.parser(nextInboundPart || '');
        return acc;
    }, {});
    return inbound;
}
function splitParams(inboundPayloadDefinition, paramsStr) {
    if ('shouldSplitWithBraces' in inboundPayloadDefinition && inboundPayloadDefinition.shouldSplitWithBraces) {
        return splitWithBraces(paramsStr);
    }
    if ('numTimesToFlatSplit' in inboundPayloadDefinition && inboundPayloadDefinition.numTimesToFlatSplit) {
        // TODO: Add tests.
        const allCommaParams = paramsStr.split(',');
        const params = [];
        while (params.length < inboundPayloadDefinition.numTimesToFlatSplit - 1) {
            params.push(allCommaParams[0]);
            allCommaParams.splice(0, 1); // remove this comma param
        }
        params.push(allCommaParams.join(',')); // join the remaining params beyond the max times to split back into a single string param
        return params;
    }
    if ('isRawParam' in inboundPayloadDefinition) {
        // "raw" type, don't split and just parse the entire string after the initial `:`
        return [paramsStr];
    }
    return paramsStr.split(',');
}
function parseInboundParams(_type, paramsStr) {
    const inboundPayloadDefinition = INBOUND_DEFINITIONS[_type];
    if ('zodSchema' in inboundPayloadDefinition) {
        // zod form
        const jsonObject = JSON.parse(paramsStr);
        const parsed = inboundPayloadDefinition.zodSchema.parse(jsonObject);
        return { _type, inbound: { _type, ...parsed } };
    }
    const inboundFields = parseInboundPayload(splitParams(inboundPayloadDefinition, paramsStr), inboundPayloadDefinition.definitionParts);
    return {
        _type,
        inbound: { _type, ...inboundFields }
    };
}
